import React from "react";

// Global React error boundary so any unhandled render crash shows a friendly
// recovery screen instead of leaving the patient on a blank white page.
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface to the browser console so the admin can copy/paste it for support.
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center bg-[#FAFAFA] p-6">
        <div className="max-w-md text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-[#FFF1F1] grid place-items-center mb-4">
            <span className="text-3xl">!</span>
          </div>
          <h1 className="text-2xl font-extrabold mb-2" style={{ fontFamily: "Manrope" }}>
            Something went wrong
          </h1>
          <p className="text-[#5C5C5C] mb-6 text-sm">
            We hit an unexpected error while loading this page. Your booking may have already
            been recorded — please check your email or call the clinic on 01 667 8524 before
            booking again.
          </p>
          <a href="/" className="ws-btn-primary inline-block">Start a new booking</a>
        </div>
      </div>
    );
  }
}
